import RitttzyFooter from "@/components/RitttzyFooter.vue";

export { RitttzyFooter };
